import React,{useEffect, useState, useRef} from 'react'
import { useTranslation } from 'react-i18next';
import {ReactComponent as IconCloseBlack } from '../../../../assets/icons/ic-close-black.svg';

const Add = ({ page,isOpen, title, errMsg, onOk, onCancel,maxLength}) => {
    const { t } = useTranslation()
    const [value, setValue] = useState('');
    const [Error, setError] = useState('');
    const [chkError, setChkError] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const inputRef = useRef(null); // 추가

    // ✅ Confirm Modal에서 입력값이 변경될 때마다 에러 메시지를 초기화합니다.
    useEffect(() => {
        if(errMsg){
            setError(errMsg);
            setChkError(true);
        }
    }, [errMsg]) 
    
    useEffect(() => {
        value.trim() === '' ? setDisabled(true) : setDisabled(false);
    }, [value])

    // ✅ 모달이 열릴 때 input에 포커스
    useEffect(() => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen]);

    return (
        isOpen &&
        <div className="absolute w-full h-full content-center whitespace-pre-line" style={{ top: 0, left: 0, background: 'rgba(0,0,0,0.3)' }}>
            <div className="mx-auto w-[360px] h-[180px] bg-[#DEDEDE] text-center flex flex-col rounded-[8px]">
                <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                    <div className="">{title || 'MODAL'}</div>
                    <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onCancel() }}/>
                </div>        

                <div className="flex-1 flex flex-col items-start justify-start bg-[#DEDEDE] px-[20px] mt-[35px]">
                    <input className={`admin-input-confirm w-full ${chkError && errMsg ? 'error' : ''}`} type="text" 
                        value={value} 
                        ref={inputRef}
                        onChange={(e) => {setValue(e.target.value); setChkError(false);}} 
                        onKeyDown={(e) => {
                            if(!disabled){
                                if(e.key === 'Enter'){
                                    onOk(value);
                                }
                            }
                        }}
                        placeholder={t(`admin.${page}.confirm.addPlaceholder`)}
                        maxLength={maxLength ? maxLength : undefined}
                    />
                    <div className={`w-full flex mt-[2px] ${chkError && errMsg ? 'justify-between' : 'justify-end'} `}>
                        {chkError && errMsg && <p className='mt-[4px] text-[#C50024] font-pretendard text-[12px] font-normal leading-[16px]'>{Error}</p>}
                        {
                            maxLength && (
                                <span className='font-pretendard text-[12px] font-normal leading-[16px] text-[#4F5057]'>{value.length} / {maxLength}</span>
                            )
                        }
                    </div>
                </div>

                <div className="flex items-center justify-end bg-[#DEDEDE] px-[20px] py-[12px] rounded-bl-[8px] rounded-br-[8px]">
                    <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] mr-[8px]  gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] cursor-pointer text-[#000] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onCancel() }}>{t('admin.cancel')}</div>
                    <div className={`${disabled ? 'opacity-30 cursor-default' : 'cursor-pointer'} flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]`} onClick={!disabled ? () => { onOk(value) } : null} >{t('admin.ok')}</div>
                </div>              
            </div>
        </div>
    )
}

export default Add